import { ColorPicker } from '@src/ui/elements/color/ColorPicker';
import { pickBgColor } from '@src/utils/colorPickerUtil';
import type { Editor } from '@tiptap/react';
import React, { useEffect, useRef, useState } from 'react';
import { FaFill } from 'react-icons/fa';

interface BackgroundColorButtonProps {
  editor: Editor;
}

export const BackgroundColorButton: React.FC<BackgroundColorButtonProps> = ({ editor }) => {
  const [showBgColors, setShowBgColors] = useState(false);
  const [recentBgColor, setRecentBgColor] = useState('#000000');
  const bgColorsRef = useRef<HTMLDivElement | null>(null);

  function handlePickBgColor(color: string) {
    pickBgColor(editor, color, setRecentBgColor);
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (bgColorsRef.current && !bgColorsRef.current.contains(event.target as Node)) {
        setTimeout(() => setShowBgColors(false), 10);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={bgColorsRef}
      className='dropdownWrapper'
      title='塗りつぶしの色'
    >
      <button
        onClick={() => setShowBgColors(!showBgColors)}
        className='toolbar-button'
        type='button'
      >
        <FaFill />
      </button>
      {showBgColors && (
        <ColorPicker
          recentColor={recentBgColor}
          onColorSelect={handlePickBgColor}
          onClose={() => setShowBgColors(false)}
        />
      )}
    </div>
  );
};
